<template>
  <el-dialog
    title="新增加液器"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="45%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      :inline="true"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="洗衣机机器ID" prop="machineid">
        <el-input v-model.trim="ruleForm.machineid"></el-input>
      </el-form-item>
      <el-form-item label="加液器IMEI" prop="liquidFeederImei">
        <el-input v-model.trim="ruleForm.liquidFeederImei"></el-input>
      </el-form-item>
      <el-form-item label="加液器型号" prop="liquidFeederModel">
        <el-input v-model.trim="ruleForm.liquidFeederModel"></el-input>
      </el-form-item>
      <el-form-item label="是否可用" prop="liquidFeederEnable">
        <el-switch v-model="ruleForm.liquidFeederEnable"></el-switch>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model="ruleForm.remark" placeholder="备注"> </el-input>
      </el-form-item>

      <div class="align-center">
        <el-button type="primary" @click="submitForm(true)">确定</el-button>
        <el-button type="primary" @click="submitForm(false)"
          >连续添加</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
// import agentVendorShop from "@/components/layout/agentVendorShop";
import enumObject from "../../../plugins/enum";
//import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      ruleForm: {
        machineid: "",
        liquidFeederImei: "",
        liquidFeederModel: "",
        liquidFeederEnable: true,
        remark: ""
      },
      rules: {
        machineid: [{ required: true, message: "请输入机器ID" }],
        liquidFeederImei: [{ required: true, message: "请输入加液器IMEI" }]
      }
    };
  },
  methods: {
    submitForm(closeDialog) {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let entity = {
            ...this.ruleForm
          };
          this.$axios(this.$urlMapping["新增加液器"], {
            data: entity
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            if (closeDialog) {
              this.$emit("closeForm");
              this.$emit("handleUpdate");
            } else {
              this.$refs["ruleForm"].resetFields();
              this.$emit("handleUpdate");
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    closeForm() {
      this.$emit("closeForm");
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value !== "");
    },
    MACHINE_STATUS_ENUM() {
      return enumObject.MACHINE_STATUS_ENUM.filter(ele => ele.value !== "");
    }
  },

  async mounted() {}
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
